// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../types/schema';

import { ClientProfileMinimalGrantorRelationshipFragment } from '../../../clientProfiles/graphql/ClientProfile.generated';
import { DispositiveProvisions_DispositiveProvisionTemplateFragment, DispositiveProvisions_DispositiveProvisionFragment } from '../../../dispositiveProvisions/graphql/DispositiveProvisions.fragments.generated';
import { gql } from '@apollo/client';
import { ClientProfileMinimalGrantorRelationshipFragmentDoc } from '../../../clientProfiles/graphql/ClientProfile.generated';
import { DispositiveProvisions_DispositiveProvisionTemplateFragmentDoc, DispositiveProvisions_DispositiveProvisionFragmentDoc } from '../../../dispositiveProvisions/graphql/DispositiveProvisions.fragments.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ClientProfileSummaryPanel_OwnershipStakeFragment = { __typename?: 'OwnershipStake', id: string, ownedValue: CurrencyUSD, ownershipPercentage?: Percent | null, ownedEntity?: { __typename?: 'Entity', id: string, subtype: { __typename?: 'CCorpBusinessEntity', id: string, displayName: string } | { __typename?: 'CLTTrust', id: string, displayName: string } | { __typename?: 'CRTTrust', id: string, displayName: string } | { __typename?: 'CustodialPersonalAccount', id: string, displayName: string } | { __typename?: 'DonorAdvisedFund', id: string, displayName: string } | { __typename?: 'GPBusinessEntity', id: string, displayName: string } | { __typename?: 'GRATTrust', id: string, displayName: string } | { __typename?: 'ILITTrust', id: string, displayName: string } | { __typename?: 'IndividualPersonalAccount', id: string, displayName: string } | { __typename?: 'InsurancePersonalAccount', id: string, displayName: string } | { __typename?: 'IrrevocableTrust', id: string, displayName: string } | { __typename?: 'JointPersonalAccount', id: string, displayName: string } | { __typename?: 'LLCBusinessEntity', id: string, displayName: string } | { __typename?: 'LPBusinessEntity', id: string, displayName: string } | { __typename?: 'PrivateFoundation', id: string, displayName: string } | { __typename?: 'QPRTTrust', id: string, displayName: string } | { __typename?: 'QualifiedTuitionPersonalAccount', id: string, displayName: string } | { __typename?: 'RetirementPersonalAccount', id: string, displayName: string } | { __typename?: 'RevocableTrust', id: string, displayName: string } | { __typename?: 'SCorpBusinessEntity', id: string, displayName: string } | { __typename?: 'SLATTrust', id: string, displayName: string } | { __typename?: 'SoleProprietorshipBusinessEntity', id: string, displayName: string } } | null };

export type ClientProfileSummaryPanel_ClientProfileFragment = { __typename?: 'ClientProfile', id: string, legalName: string, email?: string | null, displayName: string, household: { __typename?: 'Household', id: string, possiblePrimaryClients: Array<{ __typename?: 'ClientProfile', id: string, displayName: string }> }, address?: { __typename?: 'Address', id: string, cityName?: string | null, stateCode: string } | null, relationships?: Array<(
    { __typename?: 'ClientProfileRelationship' }
    & ClientProfileMinimalGrantorRelationshipFragment
  )> | null, ownedOwnershipStakes?: Array<(
    { __typename?: 'OwnershipStake' }
    & ClientProfileSummaryPanel_OwnershipStakeFragment
  )> | null, dispositionScenarios?: Array<{ __typename?: 'DispositionScenario', id: string, firstGrantorDeath: { __typename?: 'ClientProfile', id: string, displayName: string }, dispositiveProvisionsTemplate?: (
      { __typename?: 'DispositiveProvisionTemplate' }
      & DispositiveProvisions_DispositiveProvisionTemplateFragment
    ) | null, secondDeathDispositiveProvisionsTemplate?: (
      { __typename?: 'DispositiveProvisionTemplate' }
      & DispositiveProvisions_DispositiveProvisionTemplateFragment
    ) | null, dispositiveProvisions: { __typename?: 'DispositiveProvisionConnection', edges?: Array<{ __typename?: 'DispositiveProvisionEdge', node?: (
          { __typename?: 'DispositiveProvision' }
          & DispositiveProvisions_DispositiveProvisionFragment
        ) | null } | null> | null }, secondDeathDispositiveProvisions: { __typename?: 'DispositiveProvisionConnection', edges?: Array<{ __typename?: 'DispositiveProvisionEdge', node?: (
          { __typename?: 'DispositiveProvision' }
          & DispositiveProvisions_DispositiveProvisionFragment
        ) | null } | null> | null } }> | null };

export type ClientProfileSummaryPanelQueryVariables = Types.Exact<{
  where: Types.ClientProfileWhereInput;
}>;


export type ClientProfileSummaryPanelQuery = { __typename?: 'Query', clientProfiles: { __typename?: 'ClientProfileConnection', edges?: Array<{ __typename?: 'ClientProfileEdge', node?: (
        { __typename?: 'ClientProfile' }
        & ClientProfileSummaryPanel_ClientProfileFragment
      ) | null } | null> | null } };

export const Operations = {
  Query: {
    ClientProfileSummaryPanel: 'ClientProfileSummaryPanel' as const
  },
  Fragment: {
    ClientProfileSummaryPanel_OwnershipStake: 'ClientProfileSummaryPanel_OwnershipStake' as const,
    ClientProfileSummaryPanel_ClientProfile: 'ClientProfileSummaryPanel_ClientProfile' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const ClientProfileSummaryPanel_OwnershipStakeFragmentDoc = gql`
    fragment ClientProfileSummaryPanel_OwnershipStake on OwnershipStake {
  id
  ownedValue
  ownershipPercentage
  ownedEntity {
    id
    subtype {
      id
      displayName
    }
  }
}
    `;
export const ClientProfileSummaryPanel_ClientProfileFragmentDoc = gql`
    fragment ClientProfileSummaryPanel_ClientProfile on ClientProfile {
  id
  legalName
  email
  displayName
  household {
    id
    possiblePrimaryClients {
      id
      displayName
    }
  }
  address {
    id
    cityName
    stateCode
  }
  relationships {
    ...ClientProfileMinimalGrantorRelationship
  }
  ownedOwnershipStakes {
    ...ClientProfileSummaryPanel_OwnershipStake
  }
  dispositionScenarios {
    id
    firstGrantorDeath {
      id
      displayName
    }
    dispositiveProvisionsTemplate {
      ...DispositiveProvisions_DispositiveProvisionTemplate
    }
    secondDeathDispositiveProvisionsTemplate {
      ...DispositiveProvisions_DispositiveProvisionTemplate
    }
    dispositiveProvisions(orderBy: {direction: ASC, field: DISPOSITION_ORDER}) {
      edges {
        node {
          ...DispositiveProvisions_DispositiveProvision
        }
      }
    }
    secondDeathDispositiveProvisions(
      orderBy: {direction: ASC, field: DISPOSITION_ORDER}
    ) {
      edges {
        node {
          ...DispositiveProvisions_DispositiveProvision
        }
      }
    }
  }
}
    ${ClientProfileMinimalGrantorRelationshipFragmentDoc}
${ClientProfileSummaryPanel_OwnershipStakeFragmentDoc}
${DispositiveProvisions_DispositiveProvisionTemplateFragmentDoc}
${DispositiveProvisions_DispositiveProvisionFragmentDoc}`;
export const ClientProfileSummaryPanelDocument = gql`
    query ClientProfileSummaryPanel($where: ClientProfileWhereInput!) {
  clientProfiles(where: $where) {
    edges {
      node {
        ...ClientProfileSummaryPanel_ClientProfile
      }
    }
  }
}
    ${ClientProfileSummaryPanel_ClientProfileFragmentDoc}`;

/**
 * __useClientProfileSummaryPanelQuery__
 *
 * To run a query within a React component, call `useClientProfileSummaryPanelQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientProfileSummaryPanelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientProfileSummaryPanelQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useClientProfileSummaryPanelQuery(baseOptions: Apollo.QueryHookOptions<ClientProfileSummaryPanelQuery, ClientProfileSummaryPanelQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClientProfileSummaryPanelQuery, ClientProfileSummaryPanelQueryVariables>(ClientProfileSummaryPanelDocument, withFetchPolicyContext(options));
      }
export function useClientProfileSummaryPanelLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClientProfileSummaryPanelQuery, ClientProfileSummaryPanelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClientProfileSummaryPanelQuery, ClientProfileSummaryPanelQueryVariables>(ClientProfileSummaryPanelDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useClientProfileSummaryPanelSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ClientProfileSummaryPanelQuery, ClientProfileSummaryPanelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ClientProfileSummaryPanelQuery, ClientProfileSummaryPanelQueryVariables>(ClientProfileSummaryPanelDocument, withFetchPolicyContext(options));
        }
export type ClientProfileSummaryPanelQueryHookResult = ReturnType<typeof useClientProfileSummaryPanelQuery>;
export type ClientProfileSummaryPanelLazyQueryHookResult = ReturnType<typeof useClientProfileSummaryPanelLazyQuery>;
export type ClientProfileSummaryPanelSuspenseQueryHookResult = ReturnType<typeof useClientProfileSummaryPanelSuspenseQuery>;
export type ClientProfileSummaryPanelQueryResult = Apollo.QueryResult<ClientProfileSummaryPanelQuery, ClientProfileSummaryPanelQueryVariables>;